<template>
    <div class="add-event">
        <form ref="create-event" @submit.prevent="createEvent()">
            <div class="form-name">Створити подію</div>
            
            <div class="form-group">
                <label class="text" for="name">Назва:</label>
                <input id="name" class="string" type="text" v-model="name" required>
            </div>

            <div class="form-group">
                <label class="text" for="date-start">Час початку:</label>
                <input id="date-start" class="date" type="datetime-local" v-model="dateStart" required>
            </div>

            <div class="form-group">
                <label class="text" for="date-end">Час закінчення:</label>
                <input id="date-end" class="date" type="datetime-local" v-model="dateEnd" required>
            </div>

            <div class="form-group buttons">
                <button type="submit" class="btn create">Створити</button>
                <button type="reset" class="btn reset">Скинути</button>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data : () => ({
        name : '',
        dateStart : '',
        dateEnd : ''
    }),
    methods : {
        createEvent(){
            let tempStartDate = new Date(this.dateStart);
            let tempEndDate = new Date(this.dateEnd);

            let utcDateStart = new Date(Date.UTC(tempStartDate.getUTCFullYear(), tempStartDate.getUTCMonth(), tempStartDate.getUTCDate(), tempStartDate.getUTCHours(), tempStartDate.getUTCMinutes(), tempStartDate.getUTCSeconds()));
            let utcDateEnd = new Date(Date.UTC(tempEndDate.getUTCFullYear(), tempEndDate.getUTCMonth(), tempEndDate.getUTCDate(), tempEndDate.getUTCHours(), tempEndDate.getUTCMinutes(), tempEndDate.getUTCSeconds()));

            console.log(utcDateStart.toString());

            let currentEvent = {
                Name : this.name,
                Start : utcDateStart,
                End : utcDateEnd
            }
            
            axios.interceptors.request.use((config) => {
                var token = sessionStorage.getItem('access_token');
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            });

            axios.post(location.protocol + '/api/Admin/CreateEvent', currentEvent)
            .then(response => {
                console.log(response);
                this.$refs['create-event'].reset();
            })
        }
    }
}
</script>

<style lang="scss">
@import '../../../assets/style/form.scss';

.add-event{
    padding: 40px 60px;
}
</style>